module.exports = __webpack_public_path__ + "img/tasks.7a7a455f.svg";